import PocketBase from 'pocketbase';

const requestTimeout = 5000;
const pocketBaseClient = new PocketBase('/');

const getFileURL = (record, file) => {
  if (!file) return '';
  if (/^(?:https?:|data:|blob:)/i.test(file) || file.startsWith('/')) return file;
  return pocketBaseClient.files.getURL(record, file);
};

const normalizeNewsRecord = (record) => ({
  ...record,
  id: record.key || record.id,
  mainPicture: getFileURL(record, record.mainPicture),
});

const fetchCollection = async (collection, lang) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), requestTimeout);

  try {
    const records = await pocketBaseClient.collection(collection).getFullList({
      filter: pocketBaseClient.filter('lang = {:lang}', { lang }),
      sort: '-key',
      $autoCancel: false,
      signal: controller.signal,
    });

    return {
      list: records.map(normalizeNewsRecord),
    };
  } finally {
    clearTimeout(timeoutId);
  }
};

const createPocketBaseNewsLoader = ({ collection, lang }) => {
  let request;

  return () => {
    if (!request) {
      request = fetchCollection(collection, lang)
        .catch((error) => {
          console.warn(`[pocketbase] Failed to load ${collection} (${lang}).`, error);
          return null;
        });
    }

    return request;
  };
};

export default createPocketBaseNewsLoader;
